export enum UserRole {
  Vendor = 'VENDOR',
  Team = 'TEAM',
  Admin = 'ADMIN',
  Manager = 'MANAGER',
  SuperAdmin = 'SUPERADMIN',
  Client = 'CLIENT',
  AdminOperations = 'ADMIN_OPERATIONS',
  EnterpriseConcierge = 'ENTERPRISE_CONCIERGE',
  EnterprisePartner = 'ENTERPRISE_PARTNER',
  EnterprisePartnerPII = 'ENTERPRISE_PARTNER_PII',
  EnterpriseLead = 'ENTERPRISE_LEAD',
  Service = 'SERVICE',
}

enum userType {
  Vendor = 'Vendor',
  Staff = 'Staff',
  Consumer = 'Consumer',
  EnterprisePartner = 'Enterprise Partner',
}

export const mapRolesToUserTypes = (role: UserRole) => {
  switch (role) {
    case UserRole.Vendor:
    case UserRole.Team:
      return userType.Vendor;
    case UserRole.Admin:
    case UserRole.Manager:
    case UserRole.SuperAdmin:
    case UserRole.AdminOperations:
    case UserRole.EnterpriseConcierge:
      return userType.Staff;
    case UserRole.Client:
      return userType.Consumer;
    case UserRole.EnterprisePartner:
    case UserRole.EnterprisePartnerPII:
      return userType.EnterprisePartner;
    default:
      return role;
  }
};
